import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

const ContentWrapper = styled.div`
  width: 100%;
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
  text-align: left;
  position: relative;
`;

const TextWrapper = styled.span`
  > span {
    color: #7b7b7b;
  }
  .bold {
    font-weight: 700;
    color: #323232;
  }
`;

const ButtonWrapper = styled.span`
  display: inline-flex;
  position: relative;
  &::before {
    content: '';
    width: 70px;
    height: 100%;
    right: 100%;
    position: absolute;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 50%,
      #fff 100%
    );
  }
  ${({ isStickyBtn }) =>
    isStickyBtn &&
    css`
      position: absolute;
      right: 0;
      bottom: 0;
    `}
`;

const MoreButton = styled.span`
  border: none;
  outline: none;
  background: none;
  color: #007aff;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
  margin-left: 10px;
`;

const ToggleText = ({ shortText, longText, isStickyBtn = false }) => {
  const [showLongText, setShowLongText] = useState(false);
  const { t } = useTranslation();
  const handleButtonClick = () => {
    setShowLongText(true);
  };

  return (
    <ContentWrapper>
      <TextWrapper
        dangerouslySetInnerHTML={showLongText ? longText : shortText}
      />
      {!showLongText && (
        <ButtonWrapper isStickyBtn={isStickyBtn}>
          <MoreButton onClick={handleButtonClick}>{t('more')}</MoreButton>
        </ButtonWrapper>
      )}
    </ContentWrapper>
  );
};

export default ToggleText;
